/**
 * @module src/data
 */

/**
 *
 */
export default [
    {
        name: 'dark-11',
        description: '',
        colors: [
            '#f7867e',
            '#ffa000',
            '#82677E',
            '#2C577C',
            '#6D838A',
            '#00a0a0',
            '#355dff',
            '#7790ff',
            '#9B5656',
            '#CC9393',
            '#993D5F'
        ]
    },
    {
        name: 'Sky',
        description: '',
        colors: [
            '#68443c',
            '#b67b66',
            '#d8b29a',
            '#dbbeaa',
            '#cd9886',
            '#8b4d3e',
            '#4c423d',
            '#5a5550',
            '#943a4d',
            '#d6afa6',
            '#d9e1dd',
            '#8fabc9',
            '#4d6aa8'
        ]
    },
    {
        name: 'Velvet I',
        description: '',
        colors: [
            '#8ab5ba',
            '#a8c4c1',
            '#eadbc0',
            '#4c423d',
            '#b7ac9d',
            '#928a7e',
            '#3e6f42',
            '#7fa25a',
            '#becbb7',
            '#91afa1',
            '#406e58',
            '#8f3a43',
            '#b67b66'
        ]
    },
    {
        name: 'Velvet II',
        description: '',
        colors: [
            '#9b3738',
            '#b6c6ce',
            '#8fabc9',
            '#4d6aa8',
            '#c4d39b',
            '#7fa25a',
            '#3e6f42',
            '#becbb7',
            '#91afa1',
            '#406e58',
            '#eacfb9',
            '#dc8d67',
            '#d46c40'
        ]
    },
    {
        name: 'Masonry I',
        description: '',
        colors: [
            '#8ab5ba',
            '#a8c4c1',
            '#eadbc0',
            '#4c423d',
            '#b7ac9d',
            '#928a7e',
            '#3e6f42',
            '#7fa25a',
            '#becbb7',
            '#91afa1',
            '#406e58',
            '#8f3a43',
            '#b67b66'
        ]
    },
    {
        name: 'Masonry II',
        description: '',
        colors: [
            '#9b3738',
            '#4d6aa8',
            '#d9e1dd',
            '#8fabc9',
            '#929494',
            '#5e6061',
            '#e2cbb5',
            '#c4d39b',
            '#abc17a',
            '#a8c4c1',
            '#679dae',
            '#3e6e90',
            '#68443c'
        ]
    },
    {
        name: 'Sand I',
        description: '',
        colors: [
            '#5e6061',
            '#929494',
            '#d9e1dd',
            '#abbdc8',
            '#4d6aa8',
            '#4c423d',
            '#b7a392',
            '#406e58',
            '#91afa1',
            '#becbb7',
            '#c4d39b',
            '#7fa25a',
            '#3e6f42'
        ]
    },
    {
        name: 'Sand II',
        description: '',
        colors: [
            '#5a5550',
            '#b7ac9d',
            '#eadbc0',
            '#c6d5cc',
            '#a8c4c1',
            '#8ab5ba',
            '#9b3738',
            '#8fabc9',
            '#3e6e90',
            '#943a4d',
            '#d46c40',
            '#cd9886',
            '#d6afa6'
        ]
    },
    {
        name: 'Scenery',
        description: '',
        colors: [
            '#68443c',
            '#b67b66',
            '#d8b29a',
            '#8b4d3e',
            '#cd9886',
            '#dbbeaa',
            '#e6cdbf',
            '#eadbc0',
            '#9b3738',
            '#d6afa6',
            '#943a4d',
            '#8f3a43',
            '#929494'
        ]
    },
    {
        name: 'Checkered III',
        description: '',
        colors: [
            '#68443c',
            '#b67b66',
            '#d8b29a',
            '#406e58',
            '#cd9886',
            '#dbbeaa',
            '#e6cdbf',
            '#eadbc0',
            '#9b3738',
            '#d6afa6',
            '#7fa25a',
            '#8f3a43',
            '#929494'
        ]
    },
    {
        name: 'light-13',
        description: '',
        colors: [
            '#7ef7f3',
            '#bdfc8f',
            '#749afc',
            '#f49ffc',
            '#acd7f9',
            '#b5fcff',
            '#f4af9c',
            '#ff8ca7',
            '#aef495',
            '#74c9e0',
            '#ffe396'
        ]
    }
] as const;
